import { DefaultContext } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { GetToken } from "@clerk/types";
import { HASURA_CLIENT_TOKEN_KEY } from "@/config";
import { CLERK_JWT_HASURA_TEMPLATE } from "@/types";

export type ApolloContext =
  | { noAuth?: boolean; headers: { authorization: string } }
  | {
      noAuth: boolean;
      headers: { [HASURA_CLIENT_TOKEN_KEY]: string };
    };

async function getAuthorizationHeader(getClerkToken: GetToken) {
  const token = await getClerkToken(CLERK_JWT_HASURA_TEMPLATE);

  if (token) {
    return {
      authorization: `Bearer ${token}`,
    };
  }

  return {};
}

export function getAuthLink(getClerkToken: GetToken) {
  return setContext(async (_, prevContext: DefaultContext) => {
    // Get the authentication token from cookie
    const previousContext = prevContext as ApolloContext;

    const isClientTokenAuth =
      previousContext?.headers &&
      HASURA_CLIENT_TOKEN_KEY in previousContext.headers;

    const newHeaders =
      !previousContext?.noAuth && !isClientTokenAuth
        ? await getAuthorizationHeader(getClerkToken)
        : {};

    return {
      headers: {
        ...previousContext?.headers,
        ...newHeaders,
      },
    };
  });
}
